<template>
  <div>
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240);background: #ffffff"
      title="系列模特展示"
      :breadcrumb=" { props: { routes:[{path:'/',breadcrumbName:$t('HOME')}
      ,{path:`/goods-series-gather/${seriesId}`,breadcrumbName:'系列模特展示'}
      ] } }"
    />
    <div style="position: relative">
      <a-menu :defaultSelectedKeys="['goods']" mode="horizontal">
        <a-menu-item
          key="goods"
          :disabled="!seriesId">
          <a-icon type="appstore"/>
          系列模特展示
        </a-menu-item>
      </a-menu>
      <a-space style="position: absolute;right: 8px;top: 8px;">
        <a-button type="primary" @click="addSeriesGather">
          {{ $t('ADD') || '添加' }}
        </a-button>
        <a-button @click="onCancel">
          {{ $t('BACK') || '返回' }}
        </a-button>
      </a-space>
    </div>
    <a-card :bordered="false">
      <div>
        <a-row :gutter="28">
          <a-col
            :span="7"
            v-for="item in table.data"
            :key="item.id">
            <a-card
              style="margin-bottom: 20px"
              hoverable>
              <img
                slot="cover"
                alt="example"
                class="cover-img"
                :src="item.coverPath"/>
              <template slot="actions" class="ant-card-actions">
                <a-icon type="edit" @click="editSeriesGather(item.id)"/>
                <a-icon type="eye" @click="detailSeriesGather(item.id)"/>
                <a-icon type="close" @click="deleteSeriesGather(item.id)"/>
                <a-icon type="left" @click="upIndex(item.id)"/>
                <a-icon type="right" @click="downIndex(item.id)"/>
              </template>
            </a-card>
          </a-col>
        </a-row>
      </div>
      <a-modal
        :footer="null"
        append-to-body
        :title="$t('PREVIEW')||'预览'"
        v-model="form.visible">
        <goods-series-gather-edit
          v-if="form.visible"
          :gather-id="form.data.id"
          :series-id="this.seriesId"
          :on-cancel-handler="closeForm"
          :on-submit-handler="closeForm"
        />
      </a-modal>
    </a-card>
  </div>

</template>

<script>
import {
  _deleteGoodsSeriesGather,
  _downWebsiteSeriesGather,
  _queryGoodsSeriesGathers,
  _upWebsiteSeriesGather,
} from '@/api/websiteGoodsSeriesGatherApi';
import GoodsSeriesGatherEdit from './GoodsSeriesGatherEdit.vue';

async function initData() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryGoodsSeriesGathers({
    seriesId: this.seriesId,
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
  this.table.query.total = result.totalElements;
}

function onCancel() {
  this.$router.go(-1);
}

function addSeriesGather() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editSeriesGather(id) {
  this.form.data.id = id;
  this.form.visible = true;
}

function deleteSeriesGather(id) {
  this.$confirm({
    title: '是否删除',
    content: '',
    onOk: async () => {
      await _deleteGoodsSeriesGather(id);
      this.$message.success('删除成功');
      this.initData();
    },
  });
}

function detailSeriesGather(seriesId) {
  this.$router.push(`/goods-series-gather/${seriesId}/positions`);
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.initData();
}

async function upIndex(seriesGatherId) {
  this.$confirm({
    title: '是否上移？',
    content: '',
    onOk: async () => {
      await _upWebsiteSeriesGather(seriesGatherId);
      this.initData();
      this.$message.success('上移成功');
    },
  });
}

async function downIndex(seriesGatherId) {
  this.$confirm({
    title: '是否下移？',
    content: '',
    onOk: async () => {
      await _downWebsiteSeriesGather(seriesGatherId);
      this.initData();
      this.$message.success('下移成功');
    },
  });
}

// async function updateSortList(oldIndex, newIndex) {
//   const idStr = this.table.data.map(x => x.id).join(',')
//   const sortStr = this.table.data.map(x => x.sort).join(',')
//   const result = await _updateGoodsSort({
//     idStr,
//     sortStr,
//     oldIndex,
//     newIndex
//   })
//   if (result) {
//     this.$message.success('移动排序成功')
//     await this.initData();
//   }
// }
//
// function initSortable() {
//   const el = this.$refs.dragTable.$el.querySelector('.ant-table-tbody')
//   const dragTable = Sortable.create(el, {
//     handle: 'td:nth-child(4)',
//     animation: 150,
//     // 利用更新
//     onUpdate: (e) => {
//       const oldIndex = e.oldIndex
//       const newIndex = e.newIndex
//       if (oldIndex === newIndex) {
//         return
//       }
//       this.updateSortList(oldIndex, newIndex)
//     },
//   })
// }

const columns = [
  {
    title: '图片',
    scopedSlots: { customRender: 'img' },
  },
  {
    title: '商品',
    scopedSlots: { customRender: 'goodsId' },
  },
  // {
  //   title: '拖拽排序',
  //   dataIndex: 'id',
  //   align: 'center',
  //   scopedSlots: { customRender: 'sort' },
  // },
  {
    title: '操作',
    width: 300,
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'GoodsSeriesGatherList',
  components: { GoodsSeriesGatherEdit },
  props: {
    seriesId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    seriesId() {
      if (this.seriesId) {
        this.initData();
      }
    },
  },
  methods: {
    onCancel,
    initData,
    addSeriesGather,
    editSeriesGather,
    deleteSeriesGather,
    closeForm,
    detailSeriesGather,
    upIndex,
    downIndex,
    // initSortable,
    // updateSortList,
  },
  data() {
    return {
      topic: {
        data: [],
      },
      table: {
        columns,
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'sort',
          order: 'descending',
        },
      },
      form: {
        loading: false,
        visible: false,
        data: {
          id: '',
        },
        rules: {
          name: [{
            required: true,
            trigger: 'blur',
          }],
          type: [{
            required: true,
            trigger: 'blur',
          }],
        },
        title: '',
      },
    };
  },
  // mounted() {
  //   this.initSortable();
  // },
  async created() {
    if (this.seriesId) {
      await this.initData();
    }
  },
};
</script>
